var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-container"},[_c('GChart',{attrs:{"settings":{ packages: ['orgchart'] },"createChart":_vm.drawChart,"type":"OrgChart","data":_vm.chartData,"id":"chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }